module.exports = __webpack_public_path__ + "images/assets/da964ecbb10f2615911f2ad259a13429.svg";